import CalendarSurfaceAddinsOptionState from '../store/schema/CalendarSurfaceAddinsOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

const CALENDAR_SURFACE_ADDINS_OPTION_NAME = 'calendarSurfaceAddins';

export interface SelectCalendarSurfaceAddinsOptionState {
    optionState: CalendarSurfaceAddinsOptionState;
}

export default select<SelectCalendarSurfaceAddinsOptionState>({
    optionState: () => store,
})(
    action('selectCalendarSurfaceAddinsOption')(function selectCalendarSurfaceAddinsOption(
        addinCollection: string[],
        addinKey: string,
        checked: boolean,
        state?: SelectCalendarSurfaceAddinsOptionState
    ) {
        let { optionState } = state;

        if (checked) {
            if (addinCollection.indexOf(addinKey) == -1) {
                addinCollection.push(addinKey);
            }
        } else {
            let index = addinCollection.indexOf(addinKey);
            if (index >= 0) {
                addinCollection.splice(index, 1);
            }
        }
        optionState[CALENDAR_SURFACE_ADDINS_OPTION_NAME] = addinCollection;
    })
);
